import React from 'react';
import { Phone, Mail, ArrowUp } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { href: '#home', label: 'Home' },
    { href: '#servizi', label: 'Servizi' },
    { href: '#benefici', label: 'Benefici' },
    { href: '#processo', label: 'Il Nostro Processo' },
    { href: '#normative', label: 'Normative' },
    { href: '#contatti', label: 'Contatti' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={companyInfo.logo}
                alt="RS Logo"
                className="h-14 w-auto object-contain"
              />
              <div>
                <span className="font-bold text-xl">RS</span>
                <span className="text-sm block -mt-1 text-slate-400">
                  Igienizzazione Canali
                </span>
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md">
              {companyInfo.tagline}. Offriamo soluzioni innovative e personalizzate 
              per garantire ambienti di lavoro sani, sicuri ed efficienti.
            </p>
            <div className="flex gap-3">
              <span className="px-3 py-1.5 bg-sky-500/20 text-sky-400 rounded-full text-sm font-medium">
                AIISA
              </span>
              <span className="px-3 py-1.5 bg-sky-500/20 text-sky-400 rounded-full text-sm font-medium">
                NADCA
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Link Rapidi</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-400 hover:text-sky-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors"
                >
                  <Phone size={18} />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors"
                >
                  <Mail size={18} />
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {currentYear} {companyInfo.name}. Tutti i diritti riservati.
            </p>
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-slate-400 hover:text-sky-400 transition-colors text-sm"
            >
              <ArrowUp size={16} />
              Torna in alto
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
